import { Position } from "@blueprintjs/core"
import React from "react"
import { useNavigate } from "react-router-dom"
import ActionMenu from "components/Organisms/ActionMenu"
import ActionMenuItem from "components/Organisms/ActionMenuItem"
import ROUTES from "constants/routes.constants"
const AddNewActions = () => {
  const navigate = useNavigate()

  function handleClick(type) {
    switch (type) {
      case "dc":
        navigate(ROUTES.dcDetail("add"))
        return
      case "cpc":
        navigate({ pathname: ROUTES.dcDetail("add"), search: "?type=cpc" })
        return

      default:
        return
    }
  }

  return (
    <>
      <ActionMenu
        onClick={handleClick}
        popoverProps={{
          position: Position.BOTTOM_RIGHT,
        }}
        text="New"
        icon="plus"
        // dark={true}
      >
        <ActionMenuItem id="dc" text="New DC" icon="plus" />
        <ActionMenuItem id="cpc" text="New CPC" icon="plus" />
      </ActionMenu>
    </>
  )
}

export default AddNewActions
